import {
    RaikoBaseCardContainer, RaikoCollapsibleTable,
    RaikoGridOneColumn,
    RaikoTableTitleContainer, showErrorMessage, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {ElectionService} from "../../serverService/electionService/ElectionService";
import {useAuthState} from "../../context/AuthContext";
import {useParams} from "react-router-dom";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import AccountCheckoutDetail from "../accountTransactions/AccountCheckoutDetail";
import React from "react";
import {divIcon} from "leaflet";
import ElectionResultDetails from "./ElectionResultDetails";

export default function ElectionResult() {
    const [numberOfItem, setNumberOfItem] = useState("");
    const [electionResultData, setElectionResultData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [page, setPage] = useState(0);
    const size = 20;

    const service = new ElectionService()

    const {fundID} = useAuthState()
    const {id: electionId} = useParams()

    useEffect(() => {
            getElectionResultDataFromServer()
        }
        , [])

    function getElectionResultDataFromServer() {
        setTableLoading(true)
        service.getElectionResult(fundID, electionId).then(
            response => {
                setNumberOfItem(response.totalVotes)
                setElectionResultData([])
                response.candidatesVotesResults.map((item, index) => {
                    setElectionResultData(
                        prevState => [
                            ...prevState,
                            tablePreparation(
                                item.id,
                                (page * size) + index + 1,
                                item.title,
                                item.totalVotes,
                                item.percentOfVotes ? item.percentOfVotes : "صفر"
                            )
                        ]
                    )
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function tablePreparation(id, number, title, totalVotes, percentOfVotes) {
        return {
            id,
            number,
            title,
            totalVotes,
            percentOfVotes,
            children: <ElectionResultDetails candidateId={id}/>,
        }
    }

    function handleChangePagination(newPage) {
        setPageCount(newPage)
        getElectionResultDataFromServer()
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoTableTitleContainer
                    title={"نتیجه انتخابات"}
                    amount={numberOfItem}
                    amountTitle={"رای"}
                />
                <RaikoCollapsibleTable
                    header={electionResultColumns}
                    data={electionResultData}
                    isLoading={tableLoading}
                    pageCount={pageCount}
                    handlePaginationChange={handleChangePagination}
                    emptyListTitle={""}
                    emptyListSubtitle={""}
                />
            </RaikoGridOneColumn>

        </RaikoBaseCardContainer>
    )
}
const electionResultColumns = [
    {
        id: 'number',
        label: '#'
    },
    {
        id: 'title',
        label: 'عنوان',
    },
    {
        id: 'totalVotes',
        label: 'تعداد آرا',
    },
    {
        id: 'percentOfVotes',
        label: 'درصد آرا',
    },
];